import { LoadTender } from '@api/Trinium/Endpoints/EDI/types';
import classNames from 'classnames/bind';
import useModalParams from '@hooks/useModalParams';
import { useGridApiContext } from '@mui/x-data-grid-pro';

import cellStyles from '../../RenderCell.module.css';
const cellStylesCtx = classNames.bind(cellStyles);

export default function OrderNumberCell({ row }: { row: LoadTender }) {
	const gridApi = useGridApiContext();
	const { setSearchParameters } = useModalParams();

	const handleBtnClick = () => {
		gridApi.current.setRowSelectionModel({
			type: 'include',
			ids: new Set([row.id])
		});
		setSearchParameters({
			form: 'consignmentDetails',
			formId: String(row.csnId)
		});
	};

	/** If we have an Order Number than render a link to the Consignment Modal */
	if (row.ordNo && row.csnId) {
		/** Eventually this is going to be more complicated which is why the conditional statement */
		return (
			<span
				className={cellStylesCtx({
					['row-link']: true,
					bold: true
				})}
				onClick={handleBtnClick}
			>
				{row.ordNo}
			</span>
		);
	}

	return <span className={cellStyles.bold}>{row.jobCategory?.name}</span>;
}
